import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { clearError, loginThunk } from "../store/reducers/auth/auth.reducer";

import Loader from "./UI/Loader";
import Alert from "./UI/Alert";

const SignInLayer = () => {
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error } = useSelector((state) => state.auth);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const onSubmit = async (data) => {
    // console.log(data);
    const result = await dispatch(loginThunk(data));

    if (loginThunk.fulfilled.match(result)) {
      navigate("/");
    }
  };

  useEffect(() => {
    if (!error) return;

    const timer = setTimeout(() => {
      dispatch(clearError());
    }, 5000);

    return () => clearTimeout(timer);
  }, [error, dispatch]);

  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src="assets/images/auth/auth-img.png" alt="" />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px">
              <img src="assets/images/logo.png" alt="" />
            </Link>
            <h4 className="mb-12">Inicie sesión en su cuenta</h4>
            <p className="mb-32 text-secondary-light text-lg">
              ¡Bienvenido de nuevo! Por favor, introduzca sus datos.
            </p>
          </div>
          {loading ? <Loader type="linear" size="sm" /> : null}
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearError())}
            size="sm"
          />
          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mdi:account" />
              </span>
              <input
                type="text"
                name="username"
                className={`form-control h-56-px bg-neutral-50 radius-12 ${
                  errors.username ? "is-invalid" : ""
                }`}
                placeholder="Correo, usuario o matrícula"
                autoComplete="username"
                {...register("username", {
                  required: "Este campo es obligatorio",
                  minLength: {
                    value: 3,
                    message: "Debe tener al menos 3 caracteres",
                  },
                })}
              />
            </div>
            {errors.username && (
              <small className="text-danger mb-16 d-block">
                {errors.username.message}
              </small>
            )}
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  className={`form-control h-56-px bg-neutral-50 radius-12 ${
                    errors.password ? "is-invalid" : ""
                  }`}
                  placeholder="Contraseña"
                  {...register("password", {
                    required: "La contraseña es obligatoria",
                    minLength: {
                      value: 5,
                      message: "Debe tener al menos 6 caracteres",
                    },
                  })}
                />
              </div>
              {errors.password && (
                <small className="text-danger mb-16 d-block">
                  {errors.password.message}
                </small>
              )}
              <span
                className="cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                <Icon
                  icon={
                    showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"
                  }
                  width="22"
                />
              </span>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
            >
              {loading ? "Validando..." : "Iniciar sesión"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
